import { NewSearchBarPlaceholderContainer } from './styled';

export const NewSearchBarPlaceholder = () => (
  <NewSearchBarPlaceholderContainer>
    <span className="location" />
    <span className="button" />
  </NewSearchBarPlaceholderContainer>
);
